<template>
<el-row  >
  <el-container class="check_board" :style="{'background-color': 'white','height': pageHeight}">
    <el-main style="padding: unset">
      <el-row>
        <el-col>
          <el-menu default-active="0" class="el-menu-demo" mode="horizontal"
                   @select="handleStatusSelect">
            <el-menu-item v-for="item in menus" :key="item.id" :index="item.id">
              {{item.title}}
            </el-menu-item>
          </el-menu>
        </el-col>

      </el-row>
      <el-row style="padding-top: 10px;padding-bottom: 10px;background-color: white; margin: unset" :gutter="20">
        <el-col :span="4">
          <span>批量操作：</span>
          <el-button size="mini" type="primary" @click="batchOfPassPending">审核通过</el-button>
        </el-col>
        <el-col :span="6" >
          <el-select v-model="sortedFlag" placeholder="请选择排序方式" @change="getSortedFlag($event)" size="mini">
            <el-option label="按创建时间升序" value="1"></el-option>
            <el-option label="按商品名称升序" value="2"></el-option>
            <el-option label="按修改时间升序" value="3"></el-option>
            <el-option label="按创建时间降序" value="4"></el-option>
            <el-option label="按商品名称降序" value="5"></el-option>
            <el-option label="按修改时间降序" value="6"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input
              placeholder="请输入商品名称搜索"
              v-model="searchInput"
              size="mini"
              @change="searchSkuProduct">
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchSkuProduct(searchInput)"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table
              ref="multipleTable"
              :data="checkData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="headerClass"
              @selection-change="handleSelectionChange"
              @select-all="selectAll"
          >
            <el-table-column align="center" width="65" type="selection"></el-table-column>
            <el-table-column
                prop="img"
                label="图片"
                align="center">
              <template slot-scope="scope">
                <el-image
                    :src="scope.row.image[0]"
                    style="width:50px; height: 50px"
                    fit="fill"
                    :key="scope.row.image[0]">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
                prop="title"
                label="名称"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="price"
                label="售价 (元)"
                align="center">
              <!--                <template slot-scope="scope">-->
              <!--                  <el-input v-model="scope.row.price"></el-input>-->
              <!--                </template>-->
            </el-table-column>
            <el-table-column
                prop="stock"
                label="库存"
                align="center">
            </el-table-column>
            <el-table-column
                prop="specification"
                label="规格"
                align="center">
            </el-table-column>
            <el-table-column
                prop=""
                label="审核状态"
                align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 3" style="color: green">待审核</span>
                <span v-if="scope.row.status === 4" style="color: red">已驳回</span>
                <el-tooltip class="item" effect="dark"
                            :content="scope.row.operationReason"
                            placement="top"
                            v-if="scope.row.status === 4"
                >
                  <div v-if="scope.row.status === 4" class="rejectReason">
                    {{ scope.row.operationReason }}
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                prop="operation"
                label="操作"
                width="200"
                align="center">
              <template slot-scope="scope">
                <el-button
                    type="text"
                    @click="getProductDetailsOrPending('商品详情',scope.row)"
                >商品详情
                </el-button>
                <el-button
                    type="text"
                    v-if="statusMenu.choiceStatus === '待审核'"
                    @click="getProductDetailsOrPending('审核商品',scope.row)"
                >审核
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

      </el-row>
    </el-main>
    <el-footer>
      <el-col style="padding-top: 10px;padding-bottom: 10px">
        <!--      <el-container>-->
        <!--        <el-footer>-->
        <el-pagination
            @size-change="handlePageSizeChange"
            @current-change="handleCurrentPageChange"
            :current-page="pageInfo.current"
            :page-sizes="[10, 50, 100]"
            :page-size="pageInfo.size"
            layout="sizes, prev, pager, next, total"
            :total="pageInfo.total">
        </el-pagination>
        <!--        </el-footer>-->
        <!--      </el-container>-->
      </el-col>
    </el-footer>
  </el-container>
  <!--    审核-->
  <el-dialog :title="mode"
             :visible.sync="dialogFormVisible"
             width="750px"
             :before-close="handleDialogClose"
             @close="initDialog('form')"
  >
    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="80px"
             style="margin-right: 10px; margin-left: 10px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品名称" prop="spuTitle">
            <el-input v-model="form.spuTitle" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品分类" prop="spuClassId">
            <el-select v-model="form.spuClassId" placeholder="请选择" disabled>
              <el-option
                  v-for="item in categories"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="单价(元)" prop="skuPrice">
            <el-input v-model="form.skuPrice" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品库存" prop="skuStock">
            <el-input v-model.number="form.skuStock" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="规格类型" prop="skuTag">
            <el-select v-model="form.skuTag" placeholder="请选择" disabled>
              <el-option v-for="item in tags" :key="item.index" :label="item.title" :value="item.index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格" prop="skuSpecification">
            <el-input v-model="form.skuSpecification" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品来源" prop="source">
            <el-input v-model="form.source" placeholder="请输入" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="比价图片" prop="skuSpecification" class="imageUpload">
            <div class="imageGroup">
              <el-image
                  v-for="item in priceImg"
                  :src="item"
                  :preview-src-list="priceImg"
                  style="width: 50px;height: 50px;margin-right: 10px;border-radius: 5px"
                  :key="item"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div v-if="priceImg.length !== 0" style="line-height: 0;margin-top: 8px;text-align: left">比价日期：{{priceDate}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form-item label="商品描述" prop="spuDescription" >
          <el-input type="textarea" v-model="form.spuDescription" disabled></el-input>
        </el-form-item>
      </el-col>
      <!--        <el-col :span="24" v-if="mode==='新增规格' || mode ==='新建商品'">-->
      <el-col :span="24">
        <el-form-item label="商品图片" class="is-required imageUpload">
          <div class="imageGroup">
            <el-image
                v-for="item in imageList"
                :src="item"
                :preview-src-list="imageList"
                style="width: 50px;height: 50px;margin-right: 10px;border-radius: 5px"
                :key="item"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-form-item>
      </el-col>
      <!--        <el-col :span="24" v-if="mode==='新增规格' || mode ==='新建商品'">-->
      <el-col :span="24">
        <el-form-item label="商品海报" prop="posts" class="imageUpload">
          <div class="imageGroup">
            <el-image
                v-for="item in postImg"
                :src="item"
                :preview-src-list="postImg"
                style="width: 50px;height: 50px;margin-right: 10px;border-radius: 5px"
                :key="item"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-form-item>
      </el-col>
      <el-col>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <template v-if="mode === '商品详情'">
          <el-button @click="dialogFormVisible = false">关闭</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="passPending">审核通过</el-button>
          <el-button type="danger" @click="innerDialogFormVisible = true">驳回申请</el-button>
        </template>
      </span>
    <!--      驳回理由填写-->
    <el-dialog
        title="驳回理由"
        append-to-body
        :visible.sync="innerDialogFormVisible"
        :before-close="handleDialogClose"
        @close="rejectReason = ''"
    >
      <el-input v-model="rejectReason" type="textarea" placeholder="必填" maxlength="255" show-word-limit></el-input>
      <span style="color: red" v-if="rejectReason.length === 0">未填写驳回理由！</span>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="rejectPending">提交</el-button>
        </span>
    </el-dialog>
  </el-dialog>
</el-row>
</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "CommodityCheckHospitalVer",
  data(){
    return{
      GLOBAL,
      menus: [
        {
          title: "待审核",
          id: '0'
        },
        {
          title: "已驳回",
          id: '1'
        },
      ],
      //页面高度
      pageHeight: '',
      //搜索内容
      searchInput:'',
      //排序参数
      orderMethod:{
        order:'asc',
        orderKey:'createdTime',
      },
      //排序方式
      sortedFlag:'1',
      checkData: [],
      //状态选择
      statusMenu:{
        choiceIndex:'',
        choiceStatus:'待审核',
      },
      // 分页信息
      pageInfo: {
        // 分页信息
        current: 1,
        size: 10,
        total: 0,
      },
      //填写的表单
      form:{
        spuTitle:'',
        spuDescription:'',
        spuImage:[],
        spuClassId:'',
        skuSpecification:'',
        skuTag:'',
        source: '',
        skuImage:[],
        skuPrice:'',
        skuStock:'',
        images:[],
        posts:[],
      },
      formBack:{
        spuTitle:'',
        spuDescription:'',
        spuImage:[],
        spuClassId:'',
        skuSpecification:'',
        skuTag:'',
        source: '',
        skuImage:[],
        skuPrice:'',
        skuStock:'',
        images:[],
        posts:[],
      },
      mode: '',
      dialogFormVisible: false,
      innerDialogFormVisible: false,
      rejectReason: '',
      //上传部分的图片预览数组
      imageList:[],
      imgValid:true,
      //上传海报，sku级别
      postImg:[],
      //比价图片
      priceImg: [],
      //规格表单
      specificationForm:{},
      // 验证规则
      rules: {
        spuTitle: [
          {required: true, message: '请输入商品名称', trigger: 'blur'},
        ],
        spuClassId: [
          {required: true, message: '请选择商品类别', trigger: 'change'}
        ],
        skuPrice: [
          {required: true, message: '请输入价格',},
        ],
        skuStock: [
          {required: true, message: '请输入库存',},
        ],
        skuSpecification: [
          {required: true, message: '每次只能输入一种规格',},
        ],
        source:[
          {required: true, message: '请输入商品来源', trigger: 'blur'},
        ],
        spuDescription: [
          {required: true, message: '请输入商品描述',},
        ],
      },
      //商品类别
      categories:[],
      //规格类别
      tags: [
        {
          title: '尺码',
          index: 'SIZE_CHINESE'
        },
        {
          title: '非尺码',
          index: 'SIZE_ENGLISH'
        }
      ],
      //提交的表单
      productForm: {
        spu:{
          title: '',
          description: '',
          image:[],
          classId: '',
        },
        sku:{
          specification:'',
          tag:'',
          image:[],
          post:[],
          price:'',
          stock:'',
          comparison: [],
        }
      },
      //多选
      multipleSelection: [],
      selectedIds: [],
    }
  },
  methods:{
    handleStatusSelect(key){
      if(key === '0'){
        this.statusMenu.choiceStatus = "待审核";
        this.statusMenu.choiceIndex = '0';
      }else {
        this.statusMenu.choiceStatus = "已驳回";
        this.statusMenu.choiceIndex = '1';
      }
    },
    //排序
    getSortedFlag(e){
      if(e === '1'){
        this.orderMethod.order = 'asc';
        this.orderMethod.orderKey = 'createdTime';
      }else if(e === '2'){
        this.orderMethod.order = 'asc';
        this.orderMethod.orderKey = 'title';
      }else if(e === '3'){
        this.orderMethod.order = 'asc';
        this.orderMethod.orderKey = 'updatedTime';
      }else if(e === '4'){
        this.orderMethod.order = 'desc';
        this.orderMethod.orderKey = 'createdTime';
      }else if(e === '5'){
        this.orderMethod.order = 'desc';
        this.orderMethod.orderKey = 'title';
      }else if(e === '6') {
        this.orderMethod.order = 'desc';
        this.orderMethod.orderKey = 'updatedTime';
      }
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(e);
        console.log(this.orderMethod);
      }
    },
    //搜索
    searchSkuProduct(key){
      this.$store.dispatch("ProductHospitalVer/searchByKeyAndClassIdAndStatus",{
        page:this.pageInfo.current,
        pageSize:this.pageInfo.size,
        order:this.orderMethod.order,
        orderKey:this.orderMethod.orderKey,
        status:this.statusMenu.choiceStatus,
        key:key,
        source: '审核端',
      })
          .then( (res) => {
            this.checkData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.checkData.forEach( item => {
              //去除[""]这样的不合法图片
              if(item.post.length === 1 && item.post[0] === ""){
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log("搜索结果：",res);
            }
          })
          .catch( (res => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          }))
    },
    //表头样式
    headerClass() {
      return 'background: #EBEEF5'
    },
    //  待审核
    getPendingOrUncheckedList(){
      this.$store.dispatch("ProductHospitalVer/searchByKeyAndClassIdAndStatus", {
        order:this.orderMethod.order,
        orderKey:this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size,
        status:this.statusMenu.choiceStatus,
        source: '审核端',
        key: ''
      })
          .then((res) => {
            this.checkData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            // this.uncheckedLength = 0;
            this.checkData.forEach( item => {
              //去除[""]这样的不合法图片
              if(item.post.length === 1 && item.post[0] === ""){
                item.post = []
              }
              // if(item.status === 3){
              //   this.uncheckedLength += 1;
              // }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //查看商品详情 或者 审核
    getProductDetailsOrPending(mode,info){
      this.mode = mode;
      console.log(mode);
      this.dialogFormVisible = true;
      this.form.spuTitle = info.title;
      this.changedName = info.title;
      this.form.spuClassId = info.classId;
      this.form.spuDescription = info.description;
      this.form.skuPrice = info.price;
      this.form.skuStock = info.stock;
      this.form.skuTag = info.tag;
      this.form.source = info.source;
      this.form.skuSpecification = info.specification;
      this.skuId = info.id;
      this.spuId = info.spuId;
      this.sales = info.sales;
      this.imageList = info.image;
      this.postImg = info.post;
      this.priceImg = [];
      info.comparison.forEach((item) => {
        this.priceImg.push(item.url);
      })
      this.priceDate = info.comparison[0].time;
      console.log(this.priceDate);
    },
    //通过审核（非批量）
    passPending() {
      this.$confirm('确认通过审核吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        ids.push(this.skuId)
        this.$store.dispatch("ProductHospitalVer/passPending", ids)
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getPendingOrUncheckedList();
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            });
        this.$message({
          type: 'success',
          message: '审核成功!'
        });
        this.dialogFormVisible = false;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消通过审核'
        });
      });
    },

    //驳回审核
    rejectPending(){
      let data = {
        skuId: this.skuId,
        reason: this.rejectReason
      };
      if(this.rejectReason.length !== 0){
        this.$store.dispatch('ProductHospitalVer/rejectPending', data)
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.$message({
                type: 'success',
                message: '驳回成功!'
              });
              this.dialogFormVisible = false;
              this.innerDialogFormVisible = false;
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.$message({
                type: 'info',
                message: '已取消驳回'
              });
            })
      }
    },

    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    selectAll(){
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.multipleSelection);
      }
    },

    //批量审核通过
    batchOfPassPending(){
      if (this.multipleSelection.length === 0) {
        this.$alert('未选中任何商品', '警告', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } else {
        this.$confirm(`批量审核通过${this.multipleSelection.length}件商品, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.multipleSelection.forEach(item => {
            this.selectedIds.push(item.id)
          })
          this.$store.dispatch("ProductHospitalVer/passPending", this.selectedIds)
              .then((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
                this.getPendingOrUncheckedList();
              })
              .catch((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
              })
          this.selectedIds = [];
          this.$message({
            type: 'success',
            message: '审核通过!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          });
        });
      }
    },

    // 分页切换当前页码时调用
    handleCurrentPageChange(currentPage) {
      this.pageInfo.current = currentPage;
      this.getPendingOrUncheckedList()
    },
    // 分页尺寸更换时候调用
    handlePageSizeChange(pageSize) {
      this.pageInfo.size = pageSize;
      this.getPendingOrUncheckedList();
    },
    //获取类别
    getProductCategories(){
      return new Promise((resolve, reject) => {
        this.$store.dispatch("ProductHospitalVer/getProductCategories")
            .then((res) => {
              this.categories = res.data.data;
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              resolve("商品类别加载成功！");
            })
            .catch(() => {
              reject("商品列表加载失败！");
            });
      });
    },
    //处理意外退出的情况
    handleDialogClose(done) {
      // this.disabledFlag = false;
      if(this.mode === '审核商品'){
        this.$confirm("操作未保存，是否退出？")
            .then( () => {
              // this.$refs['form'].resetFields();
              done();
            })
            .catch( () => {
              // this.$refs['form'].resetFields();
            });
      }else{
        done();
      }
    },
    //初始化对话框
    initDialog(formName){
      this.imageList = [];
      this.postImg = [];
      this.$refs[formName].resetFields();
      this.productForm.sku.image = [];
      this.productForm.sku.post = [];
      this.productForm.spu.image = [];
      this.imgValid = true;
      console.log("关闭对话框，初始化对话框");
    },
  },
  created() {
    this.getProductCategories();
    this.getPendingOrUncheckedList();
  },
  watch:{
    //状态改变时，重新请求数据
    "statusMenu.choiceIndex"() {
      this.searchInput = '';
      this.getPendingOrUncheckedList();
    },
    //dialog打开、关闭时，都刷新数据
    dialogFormVisible:{
      handler:function (){
        this.getPendingOrUncheckedList();
      }
    },
    "orderMethod.order"(){
      this.getPendingOrUncheckedList();
    },
    "orderMethod.orderKey"(){
      this.getPendingOrUncheckedList();
    },
  },
  mounted() {
    this.pageHeight = document.documentElement.clientHeight - 60 - 10 + 'px';
    window.onresize = function () {
      this.pageHeight = document.documentElement.clientHeight - 60 - 10 + 'px';
    };
  },
}
</script>

<style scoped>
@import "../../style/InputCount.css";
.check_board{
  border: #E9EEF3 solid 10px;
}
.el-menu.el-menu--horizontal {
  border-left: solid 1px #e6e6e6;
}
.el-table td div .el-input{
  width: 50px;
}
span{
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 15px;
}
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
/*/deep/ .el-table .el-table__body-wrapper {*/
/*  overflow-x: scroll !important;*/
/*}*/
.rejectReason{
  color: #8c939d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1; /*可以显示的行数，超出部分用...表示 */
  -webkit-box-orient: vertical;
}
/*上传的图片*/
.imageUpload .imageGroup{
  display: flex;
}
</style>
